import { Navigate } from "react-router-dom";
import { useUserState } from "../../Contexts/UserContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useUserState();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
